// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  /* serviceURL: 'https://service.fleetdispatch.co.za/api',
  socketURL: 'https://service.fleetdispatch.co.za' */
  //  serviceURL: 'http://localhost:3000/api',
  //  socketURL: 'http://localhost:3000' ,
  //  serviceURL: 'https://fleetdispatch.uc.r.appspot.com/api',
  // socketURL: 'https://fleetdispatch.uc.r.appspot.com',  
  serviceURL: 'https://decoded-plane-278111.ew.r.appspot.com/api',
  socketURL: 'https://decoded-plane-278111.ew.r.appspot.com',
  // serviceURL: 'https://fleetdispatchdev-dot-decoded-plane-278111.ew.r.appspot.com/api',
  // socketURL: 'https://fleetdispatchdev-dot-decoded-plane-278111.ew.r.appspot.com'
  //  serviceURL: 'https://fleetdispatchoakley-dot-decoded-plane-278111.ew.r.appspot.com/api',
  // socketURL: 'https://fleetdispatchoakley-dot-decoded-plane-278111.ew.r.appspot.com' , 
  brokerURL:'wss://fleetdispatchlts-dot-decoded-plane-278111.ew.r.appspot.com:443'

};



// WEBPACK FOOTER //
// ./src/environments/environment.ts